import { render, staticRenderFns } from "./WebSourceManagement.vue?vue&type=template&id=7352e23e&"
import script from "./WebSourceManagement.vue?vue&type=script&lang=js&"
export * from "./WebSourceManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./WebSourceManagement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7352e23e')) {
      api.createRecord('7352e23e', component.options)
    } else {
      api.reload('7352e23e', component.options)
    }
    module.hot.accept("./WebSourceManagement.vue?vue&type=template&id=7352e23e&", function () {
      api.rerender('7352e23e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/WebSourceManagement.vue"
export default component.exports